import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi';

import { sortByTypeType } from '../../utils/constants';

type SortIconProps = {
  sortByType: string
}

const SortIcon = (props: SortIconProps) => {
  const { sortByType } = props;
  return sortByType === sortByTypeType.DESC ? <HiOutlineChevronDown className='pl-1' size={22} /> : <HiOutlineChevronUp className='pl-1' size={22} />;
}

export default SortIcon;
